import { useEffect } from 'react';
import useAuthStore from '../stores/authStore';

export default function useAuth() {
  const { token, user, loading, login, logout, restoreSession, permissionsLoaded, fetchPermissions } = useAuthStore();

  useEffect(() => {
    if (token && !user) {
      restoreSession();
    } else if (token && user && !permissionsLoaded) {
      // 頁面重新整理時 user 來自 localStorage，但 pagePermissions 未持久化
      // 此處補載權限資料，避免 PermissionsSection 等元件讀到空物件
      fetchPermissions();
    }
  }, [token, user, permissionsLoaded, restoreSession, fetchPermissions]);

  const roleLevel = user?.role_level ?? 99;

  return {
    token,
    user,
    loading,
    isAuthenticated: !!token,
    isDev: user?.role === 'dev',
    isAdmin: user?.role === 'admin',
    isDevOrAdmin: roleLevel <= 2,
    canManageUsers: roleLevel <= 4,
    roleLevel,
    login,
    logout,
  };
}
